export default "__VITE_ASSET__13dcff05__"